import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react';

export const SwitchAdTypeDialog = ({
  className,
  i18n,
  showDialog,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    hidden={!showDialog}
    modalProps={{
      className: classNames('switch-ad-type-dialog', className),
    }}
    closeButtonAriaLabel={i18n.getString(_TL_('Close'))}
    onDismiss={onCancel}
    dialogContentProps={{
      showCloseButton: true,
      type: DialogType.normal,
      title: i18n.getString(_TL_('Do you want to create another ad?')),
    }}
  >
    {/* eslint-disable-next-line react/no-danger */}
    <div dangerouslySetInnerHTML={{ __html: i18n.getString(_TL_('You can only create one ad. If you create another ad, your first ad will be deleted. Note: You can always create more ads for this campaign later. After saving your campaign, you can create ads two ways: During ad group creation in <b>Campaigns > Ad groups</b> or within <b>Campaigns > Ads & extensions</b>.')) }} />
    <DialogFooter>
      <PrimaryButton
        autoFocus
        className="dialog-confirm"
        onClick={onConfirm}
        text={i18n.getString(_TL_('Yes'))}
      />
      <DefaultButton
        className="dialog-cancel"
        onClick={onCancel}
        text={i18n.getString(_TL_('Cancel'))}
      />
    </DialogFooter>
  </Dialog>
);

SwitchAdTypeDialog.propTypes = {
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showDialog: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

SwitchAdTypeDialog.defaultProps = {
  className: '',
};
